// angular
import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// libs
import { ReportTransactionsBaseComponent } from '@luggagehero/features/shop-manager';
import { CurrencyService, InvoiceService, PayoutService, StorageManagerService } from '@luggagehero/services';
import { SharedBookingService } from '@luggagehero/shared/services/bookings';
import { SharedNotificationService } from '@luggagehero/shared/services/notification';
import { SharedPageTaggingService } from '@luggagehero/shared/services/page-tagging';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lh-report-transactions-shops',
  templateUrl: 'report-transactions.component.html',
  styleUrls: ['report-transactions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportTransactionsComponent extends ReportTransactionsBaseComponent {
  constructor(
    storageManager: StorageManagerService,
    notify: SharedNotificationService,
    bookingService: SharedBookingService,
    payoutService: PayoutService,
    invoiceService: InvoiceService,
    currencyService: CurrencyService,
    tag: SharedPageTaggingService,
    renderer: Renderer2,
    @Inject(DOCUMENT) doc,
    translate: TranslateService,
    route: ActivatedRoute,
    cd: ChangeDetectorRef,
  ) {
    super(
      storageManager,
      notify,
      bookingService,
      payoutService,
      invoiceService,
      currencyService,
      tag,
      renderer,
      doc,
      translate,
      route,
      cd,
    );
  }
}
